import { AgGridAngular } from 'ag-grid-angular';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { ChallengedUsersModalComponent } from '../challenged-users-modal/challenged-users-modal.component';
import { ChallengesService } from '../../../services/challenges.service';
import { cloneDeep } from 'lodash';
import { Component, OnInit, OnDestroy, ViewChild, Input, Renderer2, Inject, LOCALE_ID, HostListener } from '@angular/core';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { CxoneChallengesLeadCellRendererComponent } from './cxone-challenges-lead-renderer/cxone-challenges-lead-renderer.component';
import { ExportItems, TypeFormats } from 'src/shared/types/exportItem';
import { formatDate } from '@angular/common';
import { GridOptions, ColDef } from 'ag-grid-enterprise';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from 'rxjs';
import { MenuItem } from '@niceltd/sol/floating-menu/src/lib/menu-items';
import { getChallengeRewardText } from '../../../models/challenge.model';
import moment from 'moment';

@Component({
    selector: 'cv-challenges-list',
    templateUrl: './challenges-list.component.html',
    styleUrls: ['./challenges-list.component.scss']
})
export class ChallengesListComponent implements OnInit, OnDestroy {
    @ViewChild('challengesListGrid') agGrid: AgGridAngular;
    @Input() isCxone: boolean = false;

    exportFormats: { format: 'csv' | 'excel'; title: string }[] = [
        { format: 'csv', title: 'CSV' },
        { format: 'excel', title: 'Excel' }
    ];
    
    isDropdownOpen = false;

    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    onExportSelected(format: 'csv' | 'excel'): void {
        this.isDropdownOpen = false;
        this.exportCurrentChallengeReport(format);
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (!target.closest('.dropdown')) {
            this.isDropdownOpen = false;
        }
    }

    cs = null;
    search = "";
    isLoading: boolean = true;

    private columnDefs: ColDef[] = null;

    orderBy = {
        key: 'EndDate',
        reversed: true,
    };
    popOverData = [];

    _challenge = {
        Metric: "",
        Rankings: [],
        ChallengeID: undefined,
        EndDate: undefined,
        StartDate: undefined,
        players: [],
        ChallengeType: null,
        shadowBoxing: null
    };

    defaultMenuOptions: MenuItem[] = [
        {
            label: "Excel",
            svgIconName: "icon-office-excel",
            callbackFn: (item: MenuItem) => this.onExportClick(item),
        },
        {
            label: "CSV",
            svgIconName: "icon-CSV",
            callbackFn: (item: MenuItem) => this.onExportClick(item),
        }
    ];
    
    items: ExportItems = {
        excel: {
            getData: (format) => this.exportCurrentChallengeReport(format),
        },
        csv: {
            getData: (format) => this.exportCurrentChallengeReport(format),
        }
    };

    async onExportClick(menuItem: MenuItem) {
        const format = menuItem.label === 'Excel' ? 'excel' : 'csv';
        const data = await this.exportCurrentChallengeReport(format);
        let mimeType = '';
        let extension = '';
        if (format === 'excel') {
            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            extension = 'xlsx';
        } else {
            mimeType = 'text/csv';
            extension = 'csv';
        }

        const currentDate: string = moment().format('DD MMM, YYYY h:mm:ss A');
        const formattedDate: string[] = currentDate.split(' ');
        const formattedDateTime: string[] = formattedDate[3].split(':');
        const dateTimeSplitted: string = formattedDateTime[0] + 'h' + formattedDateTime[1] + 'm' + formattedDateTime[2] + 's ';
        const filename = `RunningChallenges_` + formattedDate[0] + ' ' + formattedDate[1] + formattedDate[2] + ' ' + dateTimeSplitted + formattedDate[4] + `.${extension}`;
        this.downloadFile(data, mimeType, filename);
    }

    downloadFile(data: string, mime: string, fileName: string) {
        const decodedData = atob(data);
        const buffer = new ArrayBuffer(decodedData.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < decodedData.length; i++) {
            view[i] = decodedData.charCodeAt(i) & 0xFF;
        }

        const fileData = [buffer];
        const blobObject = new Blob(fileData, { type: mime });

        const linkElement = document.createElement('a');
        document.body.appendChild(linkElement);
        linkElement.setAttribute('style', 'display: none;');

        const url = URL.createObjectURL(blobObject);
        linkElement.href = url;
        linkElement.download = fileName;

        linkElement.click();

        URL.revokeObjectURL(linkElement.href);
        linkElement.remove();
    }
      
    challengesGrid: GridOptions = null;
    historyHasBeenOpened = false; // used to not load history until the first time it is clicked
    settingsHasBeenOpened = false;
    sortedData: [];
    firstParticipant: string;
    DateFormat = "MMM d, y";
    private translationsSubscription: Subscription;

    constructor(
        private modalService: NgbModal,
        private challengesService: ChallengesService,
        private navigationService: NavigationService,
        private agGridHelperService: AgGridHelperService,
        public renderer: Renderer2,
        @Inject(LOCALE_ID) private locale: string,
    ) {
        this.cs = this.challengesService.data;
    }

    ngOnInit(): void {
        // we need to validate if we have localizedString before subscribing, as 'challengesService' is an Angular service, after the services is called, it will retain the data and we can utilize it.
        if (this.cs && this.cs.localizedStrings && this.cs.localizedStrings.size <= 0) {// there is no data in the map, then we need to make the request
            this.translationsSubscription = this.challengesService.translations.subscribe(() => {
                this.setupGrid();
                this.loadRunningChallenges();
            });
        } else { // it's not the first time that we load this component and we already have the localize strings
            this.setupGrid();
            this.loadRunningChallenges();
        }
        this.cs.showLoading = true;
    }

    ngOnDestroy(): void {
        //Reset view when navigated away
        if (this.cs) {
            this.cs.currentView = 0;
        }
        if (this.translationsSubscription) {
            this.translationsSubscription.unsubscribe();
        }
    }

    ngAfterViewChecked() {
        if (this.isCxone) {
            const headerContainerHeight = 190;
            const element = document.querySelector('.ag-root-wrapper-body');
            if (element != null) {
                this.renderer.setStyle(element, 'height', '100%');

                const body = document.querySelector('.ag-body');

                const elementBody = document.querySelector('#mat-tab-content-0-1');
                if (elementBody) {
                    const bodyValue = document.querySelector('#mat-tab-content-0-1').clientHeight - headerContainerHeight;
                    if (this.getRowCount() > 0) {
                        this.renderer.setStyle(body, 'height', bodyValue + 'px');
                        this.renderer.setStyle(body, 'overflow-y', 'auto');
                    }
                    else {
                        this.renderer.setStyle(body, 'height', '0px');
                    }

                    const noResultsState = document.querySelector('#noResultsState');
                    const noChallengesState = document.querySelector('#noChallengesState');
                    this.renderer.setStyle(noResultsState, 'height', bodyValue + 'px');
                    this.renderer.setStyle(noChallengesState, 'height', bodyValue + 'px');

                    const popupModal = document.querySelector('.ag-popup');
                    if (popupModal) {
                        this.renderer.setStyle(popupModal, 'position', 'fixed');
                        this.renderer.setStyle(popupModal, 'z-index', '5');

                        const modalTabs = document.querySelector(".ag-tab-selected");
                        const tabSelected = modalTabs.getAttribute("aria-label");

                        const popupModalDisplayed = document.querySelector('.ag-popup-child');
                        this.renderer.setStyle(popupModalDisplayed, 'top', '2px');
                        if (tabSelected == "filter") {
                            this.renderer.removeStyle(popupModalDisplayed, 'min-height');
                            this.renderer.setStyle(popupModalDisplayed, 'min-height', '207px');
                        } else {
                            this.renderer.removeStyle(popupModalDisplayed, 'min-height');
                            this.renderer.setStyle(popupModalDisplayed, 'min-height', '170px');
                        }

                        const modalSubmenu = document.querySelectorAll('.ag-theme-balham.ag-theme-cv-challenges.ag-popup')[1];
                        if (modalSubmenu) {
                            this.renderer.setStyle(modalSubmenu, 'min-height', '94px');
                            this.renderer.setStyle(modalSubmenu, 'position', 'fixed');
                            this.renderer.setStyle(modalSubmenu, 'z-index', '10');

                            if (this.agGrid?.api?.getDisplayedRowCount() > 0)
                                this.renderer.setStyle(modalSubmenu, 'top', '278px');
                            else
                                this.renderer.setStyle(modalSubmenu, 'top', '315px');
                        }
                    }
                }
            }

            this.mapScreenHeightToModalHeight();
        }
    }

    setupGrid() {
        this.columnDefs = [{
            field: 'EndDate_ForView',
            headerName: this.getLocalizedMessage("Date_Range_Column", "Date Range"),
            width: 120,
            cellRenderer: (param) => '<div class="d-flex align-items-center h-100">' + this.dateRenderer(param) + '</div>'
        }, {
            field: 'Metrics',
            headerName: this.getLocalizedMessage("Metric", "Metric"),
            width: 75,
            cellRenderer: (param) => '<div class="d-flex align-items-center h-100">' + param.value + '</div>'
        }, {
            field: 'Rankings',
            headerName: this.getLocalizedMessage("Leader_Column", "Leader"),
            width: 100,
            filter: true,
            filterValueGetter: (params) => {
                return this.getFilterValue(params);
            },
            cellRendererSelector: (params) => {
                if (this.isCxone) {
                    return { component: 'cxoneDashboardLeadCellRenderer' };
                } else {
                    return { component: 'pmDashboardLeadCellRenderer' };
                }
            },
        }, {
            field: 'TotalParticipants',
            headerName: this.getLocalizedMessage("Participants", "Participants"),
            width: 85,
            type: 'numericColumn',
            cellRenderer: (param) => '<div class="d-flex align-items-center h-100 justify-content-end">' + param.value + '</div>'
        },
        {
            field: 'ChallengeTypeName',
            headerName: this.getLocalizedMessage("Type", "Type"),
            width: 85,
            cellRenderer: (param) => `<div class="d-flex align-items-center h-100"> ${param.value} </div>`
        }, {
            field: 'Details.InvitedCount',
            headerName: this.getLocalizedMessage("Invitees_Column", "Users Invited"),
            width: 85,
            type: 'numericColumn',
            cellRenderer: (param) => '<div class="d-flex align-items-center h-100 justify-content-end">' + param.value + '</div>'
        }, {
            field: 'Wager',
            headerName: this.getLocalizedMessage("Wager", "Wager"),
            width: 70,
            cellRenderer: (param) => '<div class="d-flex align-items-center h-100">' + new CvNumberLocalizePipe().transform(param.value) + " " + getChallengeRewardText({ challengeType: param.data?.ChallengeType, getLocalizedMessage: this.getLocalizedMessage, quantity: param.value }) + '</div>',
        }];

        if(this.isCxone)
            //Remove the Type column for CxOne
            this.columnDefs.splice(4, 1);

        this.challengesGrid = this.agGridHelperService.createGridOptions({
            columnDefs: this.columnDefs,
            rowData: [],
            rowSelection: 'single',
            accentedSort: true,
            animateRows: true,
            suppressCellFocus: true,
            suppressScrollOnNewData: true,
            rowHeight: 50,
            suppressDragLeaveHidesColumns: true,
            overlayNoRowsTemplate: this.isCxone ? '<div style="display: none;"></div>': null,
            postSortRows: (X) => {
                const selectedRowNodesWithSort = [];
                this.agGrid?.api.forEachNodeAfterFilterAndSort((node) => {
                    selectedRowNodesWithSort.push(node.data);
                });
                this.sortedData = cloneDeep(selectedRowNodesWithSort);
            },

            isExternalFilterPresent: this.isExternalFilterPresent,
            doesExternalFilterPass: (node) => {
                const tmpFilter = this.search.toUpperCase();
                return (node.data.Metrics && node.data.Metrics.toUpperCase().includes(tmpFilter)
                    || node.data.EndDate_ForView && node.data.EndDate_ForView.toString().includes(tmpFilter)
                    || node.data.StartDate_ForView && node.data.StartDate_ForView.toString().includes(tmpFilter)
                    || node.data.Rankings.length != 0 && node.data.Rankings[0].Name.toUpperCase().includes(tmpFilter)
                    || node.data.TotalParticipants && node.data.TotalParticipants.toString().includes(tmpFilter)
                    || node.data.Details.InvitedCount && node.data.Details.InvitedCount.toString().includes(tmpFilter)
                    || node.data.Wager != 0 && (node.data.Wager + " " + this.getLocalizedMessage("Coins", "Coins").toUpperCase()).includes(tmpFilter))
                    || (!this.isCxone && node.data.ChallengeType && node.data.ChallengeType.toUpperCase().includes(tmpFilter));
            },
            getLocaleText: this.agGridHelperService.getLocaleText,

            components: {
                groupRenderer: this.agGridHelperService.GroupDrillDownCellRenderer,
                cxoneDashboardLeadCellRenderer: CxoneChallengesLeadCellRendererComponent,
                pmDashboardLeadCellRenderer: this.leadRendererPm,
            },

            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                menuTabs: ['filterMenuTab', 'generalMenuTab'],
            },
            onGridSizeChanged: (e) => {
                e.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => rowData.ChallengeID,
            onRowClicked: (params) => {
                this._challenge.Metric = params.data.Metrics;
                this._challenge.Rankings = params.data.Rankings.concat(params.data.NotRankings);
                this._challenge.ChallengeID = params.data.ChallengeID;
                this._challenge.StartDate = params.data.StartDate;
                this._challenge.EndDate = params.data.EndDate;
                this._challenge.players = params.data.BbPlayers;
                this._challenge.ChallengeType = params.data.ChallengeType;
                this._challenge.shadowBoxing = params.data.shadowBoxing;

                this.loadModal(this._challenge);
            }
        });
        if(this.isCxone)
            this.challengesGrid.scrollbarWidth = 8;
    }

    participantsSamePosition(data) {
        const participantsData = [...data.value];
        const sortedArray = participantsData
        .filter(({ Place, ViewScore }) => Place > 0 && ViewScore !== null)
        .sort((a, b) => {
            return a.Place - b.Place  || a.Name.localeCompare(b.Name);
        });
        this.firstParticipant = sortedArray[0]?.Name;
        const filteredArray = sortedArray.slice(1).filter(participant => participant.Place === sortedArray[0]?.Place);
        this.popOverData = filteredArray;
        return filteredArray;
    }

    getRowCountArray(): number[] {
        return Array.from({ length: this.getRowCount() }, (_, index) => index);
    }

    openPopover(popover: NgbPopover): void {
        popover.open();
        return;
    }

    loadRunningChallenges(): void {
        this.isLoading = true;
        this.challengesService.loadRunningChallenges(this.isCxone).then((response) => {
            this.isLoading = false;
            if (this.agGrid?.api) {
                this.agGrid?.api.setGridOption('rowData', this.cs.runningChallenges);
                if (this.isCxone) {
                    const element = document.querySelector('.ag-root-wrapper-body');
                    const noRows = document.querySelector('.ag-overlay-no-rows-center');
                    if (element != null)
                        this.renderer.setStyle(element, 'height', '100%');

                    if (noRows != null && this.cs.runningChallenges.length == 0)
                        this.renderer.setProperty(noRows, 'textContent', "");
                }
            }
            else
                this.challengesGrid.rowData = this.cs.runningChallenges;
        });
    }

    loadModal(object) {
        this.navigationService.showOverlay = true;
        const modalInstance = this.modalService.open(ChallengedUsersModalComponent, {
            animation: true,
            backdropClass: 'stopScrolling',
            size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered',
        });

        modalInstance.componentInstance.challengeObj = object;
        modalInstance.componentInstance.isCxone = this.isCxone;

        modalInstance.result.finally(() => {
            this.navigationService.showOverlay = false;
        });
    }

    //Renderer functions
    dateRenderer(param) {
        if (param.data.StartDate_ForView == param.value)
            return '<div style="cursor: pointer;"><span class="color-cerulean">' + this.getFormattedDate(param.value) + '</span></div>';
        else
            return '<div style="cursor: pointer;"><span class="color-cerulean">' + this.getFormattedDate(param.data.StartDate_ForView) + " - " + this.getFormattedDate(param.value) + '</span></div>';
    }

    getFormattedDate(date: string): string {
        if (!this.isCxone) return date;
        return formatDate(date, this.DateFormat, this.locale);
    }

    getFilterValue(params) {
        if (Array.isArray(params.data.Rankings)) {
            const filteredArray = this.orderFilterData(params.data.Rankings);
            return filteredArray[0]?.Name || params.data.Rankings[0]?.Name;
        }
        return '--';
    }

    orderFilterData(data) {
        const participantsData = data;
        const sortedArray = participantsData
        .filter(({ Place, ViewScore }) => Place > 0 && ViewScore !== null)
        .sort((a, b) => {
            return a.Place - b.Place  || a.Name.localeCompare(b.Name);
        });
        return sortedArray;
    }

    getLeadValue(param) {
        if (param.value != undefined && param.value != null && param.value.length != 0) {
            return param.value[0].Name;
        }
        return "--";
    }

    leadRendererPm = (param) => {
        return `
            <div class="d-flex align-items-center h-100">
                <span>${this.getLeadValue(param)}</span>
            </div>`;
    }

    //Filtering functions
    filterChanged() {
        setTimeout(() => {
            this.agGrid?.api.onFilterChanged();
        }, 0);
    }

    clearFilter() {
        this.search = "";
        this.agGrid?.api.onFilterChanged();
    }

    isExternalFilterPresent() {
        return true;
    }

    showHistory(): void {
        this.historyHasBeenOpened = true;
        this.cs.currentView = 1;
    }

    showSettings() {
        this.settingsHasBeenOpened = true;
        this.cs.currentView = 2;
    }

    getLocalizedMessage = (key: string, fallback: string): string => {
        if (this.cs && this.cs.localizedStrings && this.cs.localizedStrings.has(key)) {
            return this.cs.localizedStrings.get(key);
        }
        else { return fallback; }
    }

    async exportCurrentChallengeReport(format: TypeFormats) {
        const columnsState = this.agGrid?.api.getColumnState();
        const response = await this.challengesService.activeChallengeExportFile(format, JSON.stringify({ activeChallengeGridData: this.sortedData, columnStates: columnsState, searchValue: this.search }), this.isCxone);
        return response.data;
    };

    getRowCount() {
        return this.agGrid?.api?.getDisplayedRowCount() > 0 ? this.agGrid?.api?.getDisplayedRowCount() : 0;
    }

    mapScreenHeightToModalHeight() {
        const windowHeight = window.outerHeight;

        const minScreenHeight = 720;
        const maxScreenHeight = 1080;
        const minModalHeight = 400;
        const maxModalHeight = 760;

        const clampedScreenHeight = Math.min(maxScreenHeight, Math.max(minScreenHeight, windowHeight));

        const modalValue = minModalHeight +
            ((clampedScreenHeight - minScreenHeight) / (maxScreenHeight - minScreenHeight)) *
            (maxModalHeight - minModalHeight);

        const challengesModal = document.querySelector('.modal-content');
        const challengesModalContent = document.querySelector('.games-running-modal-container');

        if (challengesModal && challengesModalContent) {
            this.renderer.setStyle(challengesModal, 'height', modalValue + 'px');
            this.renderer.setStyle(challengesModalContent, 'height', modalValue + 'px');
        }
    }

    getCombinedLabel(): string {
        const localizedChallengeCount = this.getRowCount();
        const label = this.getRowCount() === 1 ? this.getLocalizedMessage('Challenge', 'Challenge') : this.getLocalizedMessage('Challenges', 'Challenges');
        return `${localizedChallengeCount} ${label}`;
    }
}
